<template>
  <div class="liu-xuan-test-result-page-2019">
    <div class="hint">
      正在根据你的填写，对你孩子的性格进行了分析<br/>
      其实你的孩子很聪明……<br/>
      这种性格超过了 <span>【{{ percentage }}%】</span>
    </div>
    <div class="pre-img"
         @click="handlePreImg"
         v-ym-report:MARKETING_LIUXUAN_TEST_RESULT_CLICK
    >
      <img :src="info.pre" alt="">
    </div>
    <div class="tip">点击图片查看详细的分析吧，记得保存图片哦</div>
  </div>
</template>

<script>
  import { isIOS } from '@/utils';

  export default {
    name: 'LiuXuanTestResultPage2019',
    props: {
      score: {
        type: Number,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        percentageList: [
          94.32,
          93.89,
          93.79,
          93.58,
          93.14,
          93.03,
          92.77,
          92.56,
          92.22,
          92.03,
          91.88,
          91.76,
        ],
        numberList: [5.68, 6.11, 6.21, 6.48, 6.86, 6.97, 7.23, 7.31, 7.44, 7.78, 7.97, 8.12, 8.24],
        result: [
          /* eslint-disable global-require */
          {
            key: 'qhx',
            info: [
              {
                title: '你的孩子有很多优点你没有发现',
                content: '多跟孩子交流，抓住ta身上的闪光点<br/>积极引导，足可以影响ta的一生',
              },
              {
                title: '你的孩子其实非常温暖善良',
                content: '对生活抱以期待，总是设身处地为别人着想<br/>常常忽略自己的感受，ta的存在让世界更有温度',
              },
              {
                title: '你的孩子活着是为了快乐',
                content: '苦和灵魂的无困扰追求身体的无痛不热衷无谓的竞争<br/>ta只想做一个刚刚好的明白人',
              },
              {
                title: '你的孩子常常顾全大局',
                content: '以集体利益为重，是周围人眼中极为可靠的存在<br/>超强的责任感让ta成为群体中的灵魂人物',
              },
            ],
            totem: require('@/pages/2019/LiuXuanTest/assets/img/result/r1_totem.png'),
            type: require('@/pages/2019/LiuXuanTest/assets/img/result/r1_type.png'),
            desc: require('@/pages/2019/LiuXuanTest/assets/img/result/r1_desc.png'),
            url: 'https://m.youthmba.com/topic/167',
            hint: '你说这孩子的聪明劲儿，随谁呢？<br/>妥妥的潜力股，赶紧安排',
            pre: require('@/pages/2019/LiuXuanTest/assets/img/result/r1_pre.png'),
          },
          {
            key: 'wxx',
            info: [
              {
                title: '你的孩子是天生的交际官',
                content: '虽然看起来很独立但ta还是希望有人能够及时给予陪伴<br/>多给予认可和支持，相信ta一定会厚积薄发，一鸣惊人',
              },
              {
                title: '你的孩子的激情让庸人焦虑',
                content: 'ta会不顾一切地追寻内心真正的渴望<br/>任何伟大的梦想都将臣服于ta的热血',
              },
              {
                title: '你的孩子其实非常的优秀',
                content: '拥有令人嫉妒的创造力和勇敢的灵魂，看透现实的浮躁却不附和<br/>无所畏惧的ta终将到达心中的理想国',
              },
              {
                title: '你的孩子活泼而守纪律',
                content: '勇敢而不鲁莽，具备难得的坚定意志和长远目光<br/>现实越敲打ta，ta越能绽放灿烂的光辉',
              },
            ],
            totem: require('@/pages/2019/LiuXuanTest/assets/img/result/r2_totem.png'),
            type: require('@/pages/2019/LiuXuanTest/assets/img/result/r2_type.png'),
            desc: require('@/pages/2019/LiuXuanTest/assets/img/result/r2_desc.png'),
            url: 'https://m.youthmba.com/topic/166',
            hint: '你说这孩子能说会道，随谁呢？<br/>天生交际官，能说会道就是ta',
            pre: require('@/pages/2019/LiuXuanTest/assets/img/result/r2_pre.png'),
          },
          {
            key: 'zjx',
            info: [
              {
                title: '虽然ta比其他孩子更懂事',
                content: '但一定心中一定有些委屈很少对人倾诉<br/>多对孩子关心的一些，相信ta一定能成就很多东西',
              },
              {
                title: '你的孩子忠于事实和真理',
                content: '但一定心中一定有些委屈很少对人倾诉<br/>多对孩子关心的一些，相信ta一定能成就很多东西',
              },
              {
                title: '你的孩子拥有比常人更准的直觉',
                content: '对世界的感知比普通人更敏锐，洒脱随性<br/>有着世间难得的真性情，一定要相信ta',
              },
              {
                title: '你的孩子有与生俱来的正义感',
                content: '敢于对抗偏见，ta公正的处事态度令人信服<br/>存在是伟大灵魂的觉醒，一定要给ta支持',
              },
            ],
            totem: require('@/pages/2019/LiuXuanTest/assets/img/result/r3_totem.png'),
            type: require('@/pages/2019/LiuXuanTest/assets/img/result/r3_type.png'),
            desc: require('@/pages/2019/LiuXuanTest/assets/img/result/r3_desc.png'),
            url: 'https://m.youthmba.com/topic/168',
            hint: '你说这孩子的自觉性，随谁呢？<br/>其他家长嘴边挂着的“别人家的孩子”',
            pre: require('@/pages/2019/LiuXuanTest/assets/img/result/r3_pre.png'),
          },
          {
            key: 'qxx',
            info: [
              {
                title: '你的孩子其实很特别',
                content: '虽然有一些独特的想法和行为暂时还不被理解和接受<br/>但请你相信ta，多一些耐心，相信ta一定能给你更多惊喜',
              },
              {
                title: '你的孩子可能浑身都是棱角',
                content: 'ta学不会讨好，天真锐利，不为适应规则而活<br/>但正值正是是ta在荒诞世界中前行的姿态',
              },
              {
                title: '你的孩子是命运的强者',
                content: '在世界这个优胜劣汰的竞技场里，ta的成长速度异于常人<br/>没有人能打败你的孩子，除了ta自己',
              },
              {
                title: '你的孩子宁静而深邃',
                content: '总能一针见血的看透事物本质，凭借深沉的勇气与黑暗交锋获得力量，宁愿孤独也不庸俗',
              },
            ],
            totem: require('@/pages/2019/LiuXuanTest/assets/img/result/r4_totem.png'),
            type: require('@/pages/2019/LiuXuanTest/assets/img/result/r4_type.png'),
            desc: require('@/pages/2019/LiuXuanTest/assets/img/result/r4_desc.png'),
            url: 'https://m.youthmba.com/topic/169',
            hint: '真羡慕你，有个这么与众不同的孩子。<br/>啊~真香系列，非你莫属',
            pre: require('@/pages/2019/LiuXuanTest/assets/img/result/r4_pre.png'),
          },
          {
            key: 'kfx',
            info: [
              {
                title: '可能表现出来的有些普通',
                content: '但ta还有许多优势的能力没有发挥出来<br/>多给ta些鼓励和赞赏，相信ta会带来更多惊喜',
              },
              {
                title: '你的孩子直率且专一',
                content: '善恶分明的灵魂万里挑一，拥有永不活在别人价值观里的卓越气质，以坚定的态度直面世界',
              },
              {
                title: '你的孩子独立且自由',
                content: '有个性但不任性唯己但不自私，跟随内心不从众绝不浪费自己的时间为他人而活',
              },
              {
                title: '你的孩子能感知到他人忽视的细微',
                content: 'ta内心温暖真实，活着本身就足以让ta热泪盈眶，超高的清商使ta注定不凡',
              },
            ],
            totem: require('@/pages/2019/LiuXuanTest/assets/img/result/r5_totem.png'),
            type: require('@/pages/2019/LiuXuanTest/assets/img/result/r5_type.png'),
            desc: require('@/pages/2019/LiuXuanTest/assets/img/result/r5_desc.png'),
            url: 'https://m.youthmba.com/topic/170',
            hint: '你说这孩子的这么懂事儿，随谁呢？<br/>啥都别说了，先给ta一个面子。',
            pre: require('@/pages/2019/LiuXuanTest/assets/img/result/r5_pre.png'),
          },
          /* eslint-enable global-require */
        ],
        infoRandom: Math.floor(Math.random() * 4),
        percentRandom: Math.floor(Math.random() * 12),
        resultImg: '',
      };
    },
    computed: {
      percentage() {
        return this.percentageList[this.percentRandom];
      },
      number() {
        return this.numberList[this.percentRandom];
      },
      info() {
        return this.fetchScore();
      },
      inIOS() {
        return isIOS();
      },
    },
    methods: {
      fetchScore() {
        if (this.score >= 24) return this.result[3];
        if (this.score >= 20) return this.result[2];
        if (this.score === 18) return this.result[1];
        if (this.score === 16) return this.result[0];
        if (this.score >= 12 && this.inIOS) return this.result[Math.floor(Math.random() * 3)];
        if (this.score >= 12) return this.result[4];
        return this.result[3];
      },
      handlePreImg() {
        const params = {
          name: this.name,
          number: this.number,
          info: this.info,
          infoRandom: this.infoRandom,
        };
        this.$emit('preImg', params);
      },
    },
    created() {
      this.$nextTick(() => {
        document.getElementById('page-end').scrollIntoView();
      });
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .liu-xuan-test-result-page-2019 {
    background: @color-white;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .hint {
    margin-bottom: 36px;
    font-size: @font-size-extra-small;
    color: @color-text-lighter;
    line-height: 1.8;
    text-align: center;
    span {
      font-weight: @font-weight-bold;
      color: #36aba8;
    }
  }
  .pre-img {
    width: 200px;
    height: 320px;
    display: block;
    background: #36aba8;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .tip {
    margin: 36px auto @size-base;
    font-size: @font-size-extra-small;
    color: @color-text-base;
    line-height: 1;
  }
  .action-btn {
    width: 540px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 29px;
    font-size: 26px;
    color: @color-white;
    background: #36aba8;
    img {
      margin-left: @size-extra-small;
      display: block;
      width: 22px;
      height: @size-base;
    }
  }

</style>
